// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"extra-info-item__visuallyhidden--GC6Hu","focusable":"extra-info-item__focusable--R85ub","field":"extra-info-item__field--wk4EZ"};